// extracted by mini-css-extract-plugin
module.exports = {"bar":"TitleBarWithComponent_bar__jZIVv","text":"TitleBarWithComponent_text___SeqM","content":"TitleBarWithComponent_content__Ooohj","revert":"TitleBarWithComponent_revert__c3vF8"};